import React from 'react';
import Box from '@mui/material/Box';
import logo from '../../assets/roller-logo-square.png';

/**
 * The ROLLER mark, used everywhere the app brands itself.
 *
 * Replaces the placeholder "S" tile that used to be duplicated in the login
 * screen and the sidebar. Kept as one component so the asset and its sizing
 * rules live in a single place.
 */
const Logo = ({ size = 32, sx }) => (
  <Box
    component="img"
    src={logo}
    alt="ROLLER"
    sx={{
      width: size,
      height: size,
      // The source PNG is a square with its own padding, so it needs no
      // background plate or radius of its own.
      objectFit: 'contain',
      display: 'block',
      flexShrink: 0,
      ...sx,
    }}
  />
);

export default Logo;
